import { Minus } from 'lucide-react'

import { useFormControlProps } from '@/components/ui/form-field-context'
import { cn } from '@/lib/utils'

// 使い方のルール: docs/develop/client_ui/components/form.md

// 業務ロジックを持たない汎用チェックボックス。data-table.tsx（共通 UI）が使うため components/ui/ に置く
export function CheckboxControl({
  checked,
  indeterminate,
  onChange,
  label,
  disabled = false,
}: {
  checked: boolean
  indeterminate?: boolean
  onChange: () => void
  label: string
  disabled?: boolean
}) {
  const control = useFormControlProps({})
  return (
    <button
      type="button"
      aria-invalid={control['aria-invalid']}
      aria-describedby={control['aria-describedby']}
      disabled={disabled}
      role="checkbox"
      aria-checked={indeterminate === true ? 'mixed' : checked}
      aria-label={label}
      onClick={onChange}
      className={cn(
        'flex size-4.5 items-center justify-center rounded-[5px] border transition-colors aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20',
        checked || indeterminate === true
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-input bg-card hover:border-primary/60',
      )}
    >
      {indeterminate === true ? <Minus className="size-3" strokeWidth={3} /> : checked ? <CheckIcon /> : null}
    </button>
  )
}

function CheckIcon() {
  return (
    <svg
      viewBox="0 0 12 12"
      className="size-3"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2.5 6.5 5 9l4.5-5" />
    </svg>
  )
}
